<template>
  <div class="user">
    <transition name="slide-fade" mode="out-in">
      <div v-if="params">
        <user-first-row :groupDetails="groupDetails" />

        <user-second-row-v2
          v-if="$version === 'v2'"
          :params="params"
          :study="currentStudy"
          :paramsArray="currentParamsArray"
        />
        <user-second-row
          v-else
          :params="params"
          :study="currentStudy"
          :paramsArray="currentParamsArray"
        />

        <ReviewCard
          v-if="
            dbAdminParamsToReview &&
              currentStudy.id in dbAdminParamsToReview &&
              userRole !== 'viewer'
          "
          :algoParams="dbAdminParamsToReview[currentStudy.id]"
          :groupDetails="groupDetails"
        />

        <ParametersHistoryCard
          :paramsArray="currentParamsArray"
          :params="params"
          :study="currentStudy"
        />
      </div>
      <div v-else>
        <md-progress-bar md-mode="indeterminate"></md-progress-bar>
      </div>
    </transition>
  </div>
</template>

<style scoped>
.user {
  text-align: left;
  margin-bottom: 50px;
}
</style>

<script>
import UserSecondRow from "../components/UserSecondRow";
import UserSecondRowV2 from "../components/UserSecondRowV2";
import ParametersHistoryCard from "../components/ParametersHistoryCard";
import ReviewCard from "../components/ReviewCard";
import UserFirstRow from "../components/UserFirstRow";

import { mapState } from "vuex";

export default {
  name: "user",
  components: {
    UserSecondRow,
    UserSecondRowV2,
    ParametersHistoryCard,
    ReviewCard,
    UserFirstRow
  },
  created() {
    this.$store.dispatch("fetchUser", this.$route.params.id);
  },
  beforeDestroy() {
    this.$store.dispatch("listenersOffUser");
  },
  computed: {
    ...mapState([
      "dbAdminParamsToReview",
      "dbGroups",
      "dbAdminUsers",
      "currentStudy",
      "currentParamsArray",
      "userRole"
    ]),
    params: function() {
      return this.currentStudy ? this.currentStudy.params : null;
    },
    groupDetails: function() {
      let obj = {
        study: this.currentStudy.id,
        email: null,
        name: null,
        groupName: null,
        groupId: null
      };

      if (this.dbGroups && "group" in this.currentStudy) {
        if (this.currentStudy.group in this.dbGroups) {
          let group = this.dbGroups[this.currentStudy.group];

          obj.groupId = this.currentStudy.group;
          obj.groupName = group.name;

          if ("assignedTo" in group && group.assignedTo in this.dbAdminUsers) {
            let admin = this.dbAdminUsers[group.assignedTo];

            obj.email = admin.email;
            obj.name = admin.name;
          }
        }
      }

      return obj;
    }
  }
};
</script>
